import { render, staticRenderFns } from "./RunnitBoardOwnerTableCell.vue?vue&type=template&id=c65283a8&scoped=true"
import script from "./RunnitBoardOwnerTableCell.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardOwnerTableCell.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoardOwnerTableCell.vue?vue&type=style&index=0&id=c65283a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65283a8",
  null
  
)

export default component.exports